<template>
  <div class="navbar">
    <div class="home">
      <div class="home-tp"><img src="https://szdbi.oss-cn-shenzhen.aliyuncs.com/yunzhishou-web/index_tag.png">蛮筷云店
      </div>
    </div>

    <div class="right-menu">
      <!-- <template v-if="device!=='mobile'">
        <el-tooltip content="字体大小" effect="dark" placement="bottom">
          <size-select id="size-select" class="right-menu-item hover-effect"/>
        </el-tooltip>
      </template> -->
      <!-- <div class="flashBox" @click="flash()">
        <img src="../../assets/flash.png">
      </div> -->

        <!-- style="display: block;margin-right: 10px;font-size:12px;margin-top: 2px;" -->
<!--      <el-button size="mini" @click="flash" type="primary"-->
<!--                 style="margin-right: 10px; color: #ffffff;cursor: pointer;background-color: #5faef8;border: 2px solid #7dbdfa;width: 70px">-->
<!--        高清-->
<!--      </el-button>-->
      <!-- <el-button type="danger" icon="el-icon-refresh-right" style="margin-right: 10px;font-size:12px; margin-top: 2px; padding: 2px 4px;" @click="resetToken">刷新token</el-button> -->
      <span class="openVideo">开启播报</span><el-switch
        style="display: block;margin-right: 10px;font-size:12px;margin-top: 2px;"
        v-model="isVideo"
        active-color="#13ce66"
        @change="changeVideo">
      </el-switch>
      
      <el-switch
        style="display: block;margin-right: 10px;font-size:12px;margin-top: 2px;"
        v-model="serviceStatus"
        active-color="#13ce66"
        inactive-color="#ff4949"
        :active-value=1
        :inactive-value=0
        active-text="服务中"
        inactive-text="暂停服务"
        @change="changeService">
      </el-switch>


      <div class="linkSuccess" style="margin-right: 10px; color: #ffffff;cursor: pointer;" @click="open">值守管理</div>

      <div v-if="!isLink" class="linkFail">断开服务器连接</div>
      <div v-if="isLink" class="linkSuccess">连接成功</div>

      <el-dropdown
          class="avatar-container right-menu-item hover-effect"
          trigger="click"
      >
        <div class="avatar-wrapper">
          <img
              :src="user.iconPath | image"
              class="user-avatar"
          >
          <span class="userName">{{ userName }}</span>
          <i class="el-icon-caret-bottom"/>
        </div>
        <el-dropdown-menu slot="dropdown" style="height:36px;width:80px">
          <!-- <router-link to="/">
            <el-dropdown-item>首页</el-dropdown-item>
          </router-link> -->
          <el-dropdown-item
              @click.native="logout"
          >
            <span style="display:block;">退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {convertPath} from "@/utils/validate";
import {detailCustomerService,currentCustomerService,updateServiceStatus,clearAccessToken} from "@/api/common/CustomerServiceOperationLogApi"
import {cache, getToken, removeToken, removeUserInfo} from '@/utils/localStorage'

export default {
  filters: {
    image(path) {
      return convertPath(path);
    },
  },
  components: {},
  data() {
    return {
      isVideo: false,
      userName: '',
      userInfo: {},
      webSocketUrl: `${process.env['VUE_APP_WEB_SOCKET_API']}`,
      isLink: false,
      serviceStatus: 0,
      hasUpdatedStatus: false,
      // timer: null
    }
  },
  computed: {
    ...mapGetters(["sidebar", "user", "device"]),
  },
  async created() {
    this.userInfo = await cache('userInfo')
    this.userName = this.userInfo.name
    var _this = this
    setInterval(() => {
      if (_this.$mqtt.getConnectStatus()) {
        _this.isLink = true
        if(!this.hasUpdatedStatus) {
          this.hasUpdatedStatus = true
        }
      } else { 
        _this.isLink = false
        if(!this.hasUpdatedStatus) {
          this.hasUpdatedStatus = true
        }
      }
    }, 2000)
    // this.timer = setInterval(() => {
    //   if (_this.$mqtt.getConnectStatus()) {
    //     _this.isLink = true
    //     if(!this.hasUpdatedStatus) {
    //       this.hasUpdatedStatus = true
    //     }
    //   } else { 
    //     _this.isLink = false
    //     if(!this.hasUpdatedStatus) {
    //       this.hasUpdatedStatus = true
    //     }
    //   }
    // }, 2000)
  },

  watch: {
    // 监听 hasUpdatedStatus 的变化
    hasUpdatedStatus(newValue) {
      if (newValue === true) {
        this.updateServiceStatus();
      }
    }
  },

  // beforeDestroy() {
  //   // 清除定时器
  //   clearInterval(this.timer);
  // },

  methods: {
    async open() {
      var token = await getToken();
      var s = 'https://customer.other.cloud.stores.mankuaiaa.cn/home?token=' + token;
      window.open(s);
    },
    toggleSideBar() {
      this.$store.dispatch("app/toggleSideBar");
    },
    flash() {
      window.location.reload()
    },
    // 重置token
    resetToken() {
      clearAccessToken().then(()=>{
        this.$message.success("重置成功")
      })
    },
    changeVideo() {
      this.isVideo = true;
    },
    updateServiceStatus() {
      // detailCustomerService(this.userInfo.id).then(res=>{
      //   this.serviceStatus = res.data.serviceStatus
      //   this.$forceUpdate()
      // })
      currentCustomerService().then(res=>{
        this.serviceStatus = res.data.serviceStatus
        this.$forceUpdate()
      })
    },
    changeService(e) {
      console.log(e);
      updateServiceStatus(e).then(res=>{
        this.$message.success("操作成功")
      }).catch(error => {
        // console.error(error); // Optional: log the error to the console for debugging
        this.$message.warn("操作失败");
      });
    },
    // changeLink(){
    //   this.isLink = !this.isLink
    // },
    logout() {
      this.$confirm('是否确定退出登录？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await this.$store.dispatch("user/logout").then(async () => {
          this.$message({
            type: 'success',
            message: '退出登录成功'
          });
          console.log('首页退出登录')
          await removeToken();
          await removeUserInfo()
          try {
            await this.$mqtt.disconnect();
          } catch (e) {

          }
          await this.$router.push(`/login?redirect=${this.$route.fullPath}`);
        });

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-switch__label.is-active {
  color: #5d11e9;
}
::v-deep .el-switch__label {
  color: #c5b6e0;
}
::v-deep .el-switch__label--left {
  margin-right: 5px;
}
::v-deep .el-switch__label--right {
  margin-left: 5px;
}

.navbar {
  height: 25px;
  overflow: hidden;
  position: relative;
  background: rgb(63, 149, 230);
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  display: flex;
  align-items: center;
  justify-content: space-between;

  .breadcrumb-container {
    float: left;
    display: flex !important;
    align-content: center !important;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;
    display: flex;
    align-items: center;

    .linkFail {
      color: red;
      font-size: 13px;
      margin-top: 5px;
    }

    .linkSuccess {
      color: #11e296;
      font-size: 13px;
      margin-top: 5px;
    }

    .flashBox {
      width: 50px;
      height: 50px;
      display: flex;
      margin-right: 20px;
      align-items: center;

      img {
        width: 35px;
        height: 35px;
      }
    }

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;
      display: flex;
      align-items: center;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;
        display: flex;
        align-items: center;

        .user-avatar {
          cursor: pointer;
          width: 20px;
          height: 20px;
          margin-right: 10px;
          border-radius: 10px;
        }

        .userName {
          color: #ffffff;
          margin-right: 10px;
          font-family: '微软雅黑';
          font-weight: 290;
          font-size: 12px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          // top: 30px;
          color: #ffffff;
          font-size: 15px;
        }
      }
    }
  }
}
.openVideo {
  font-size: 14px;
  font-family: '微软雅黑';
  color: #ffffff;
  margin-right: 5px;
}
.home {
  padding-left: 30px;
  display: flex;
  align-items: center;

  .home-tp {
    img {
      width: 14px;
      height: 10px;
      margin-right: 10px;
    }

    padding-right: 30px;
    display: flex;
    align-items: center;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #ffffff;
  }
}
</style>
